<template>
  <div class="live-end">
    <div class="title">本场直播已结束</div>
    <div class="content">
      <div class="item">
        <div class="date">1.5w</div>
        <div class="info">观看人次</div>
      </div>
      <div class="item">
        <div class="date">02:25:10</div>
        <div class="info">直播时长</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "live-end",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.live-end {
  position: absolute;
  z-index: 102;
  top: 1.85rem;
  left: 0.2rem;
  width: calc(100% - 0.4rem);
  height: 2.4rem;
  border-radius: 0.1rem;
  color: #fff;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.3);
    z-index: -1;
  }
  .title {
    font-size: 0.36rem;
    padding: 0.3rem 0 0.3rem;
    text-align: center;
    font-weight: bold;
  }
  .content {
    padding: 0 0.58rem 0 0.76rem;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%; 
      position: relative;
      text-align: center;
      &:nth-child(odd)::after {
        position: absolute;
        right: 0;
        top: 0;
        content: "";
        width: 0.01rem;
        height: 100%;
        background: #999;
      }
      .date {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        margin-bottom: 0.12rem;
        justify-content: center;
        .iconfont {
          margin-right: 0.13rem;
        }
      }
      .info {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.36rem;
      }
    }
  }
}
</style>
